import { TransactionDto } from "../index";

export function computeSummarizeTotal(data: TransactionDto[], paymentType?: string): number {
  return data
    .filter(it => {
      if (paymentType === "NEMURU") return it.type === "capture_approved";
      return it.status === "OK";
    })
    .map(it => (it.type === "REFUND" ? it.total * -1 : it.total))
    .reduce((acc, curr) => acc + curr, 0);
}
